import Cookies from 'js-cookie'
import md5 from 'js-md5'
import {Base64} from 'js-base64'

const Crypt = 'Crypt_web'
const TokenKey = 'Token_web'
const RoleKey = 'Admin-Role'
const SecretKey = 'SecretKey_web'
const UserId = 'UserId_web'
const UserRole = 'UserRole_web'
const UserAccount = 'UserAccount_web'
const Expire = 'Expire_web'

export function getRole() {
  return Cookies.get(RoleKey)
}

export function getCrypt() {
  return Cookies.get(Crypt)
}

export function getToken() {
  return Cookies.get(TokenKey)
}

export function getSecret() {
  return Cookies.get(SecretKey)
}

export function getUserId() {
  return Cookies.get(UserId)
}

export function getUserRole() {
  return Cookies.get(UserRole)
}

export function getUserAccount() {
  return Cookies.get(UserAccount)
}

export function getExpire() {
  return Cookies.get(Expire)
}

export function setCrypt(data) {
  return Cookies.set(Crypt, data)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function setRole(role) {
  return Cookies.set(RoleKey, role)
}

export function setSecretKey(secret_key) {
  return Cookies.set(SecretKey, secret_key)
}

export function setUserId(user_id) {
  return Cookies.set(UserId, user_id)
}

export function setUserRole(role) {
  return Cookies.set(UserRole, role)
}

export function setUserAccount(user_account) {
  return Cookies.set(UserAccount, user_account)
}

export function setExpire(expire) {
  return Cookies.set(Expire, expire)
}

export function removeToken() {
         Cookies.remove(SecretKey)
         Cookies.remove(Expire)
         Cookies.remove(RoleKey)
         Cookies.remove(UserId)
         Cookies.remove(UserAccount)
		 Cookies.remove(Crypt)
  return Cookies.remove(TokenKey)
}

export function createSign(data) {
  var token = Cookies.get(TokenKey),
      secret_key = Cookies.get(SecretKey),
      date = new Date(),
      sign_at = parseInt(date.getTime()/1000),
      sign_nonce = get_sign_nonce();
  data.token = token;
  data.sign_at = sign_at;
  data.sign_nonce = sign_nonce;
  if(data.sign){
    delete data.sign
  }
  var data = sortObj(data);
  var keys = Object.keys(data).sort();
  var arr = [];
  for (var i in keys) {
      arr[i] = keys[i]+'='+data[keys[i]];
  };
  var datastring = arr.join('&');
  var sign = md5(Base64.encode(datastring+'&'+secret_key));
  data.sign = sign;
  return data;

}

let get_sign_nonce = function(e){
    var date = new Date(),
    sign_at = date.getTime(),
    random = Math.random()*99+1;
    var get_sign_nonce = random.toString() + sign_at.toString();
    return get_sign_nonce;
}

let sortObj = function(obj) {
    if (typeof (obj) === 'Object') {
        var keys = Object.keys(obj).sort();
        var arr = {};
        for (var i in keys) {
            arr[keys[i]] = obj[keys[i]];
        }
        return arr;
    } else {
        return obj;
    }
}
